export default __webpack_public_path__ + "static/media/contractImg.a6b065a0.png";